/* import { conditionConstants } from "../../../cms/form/conditions/condition.constants"; */
import { conditionHelper } from "../../../cms/areas/form/conditions/conditionHelper";




export const conditionActions = {
    checkAll,
    triggerCheck
}

function triggerCheck(sourceElementId){
   
    conditionHelper.checkConditions(sourceElementId)
    return {type:"NONE"};
}
function checkAll(pageId){
    conditionHelper.checkAll(pageId);
    return {type:"NONE"}
}